import { render, staticRenderFns } from "./PageAdvert.vue?vue&type=template&id=086c5318&scoped=true"
import script from "./PageAdvert.vue?vue&type=script&lang=js"
export * from "./PageAdvert.vue?vue&type=script&lang=js"
import style0 from "./PageAdvert.vue?vue&type=style&index=0&id=086c5318&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086c5318",
  null
  
)

export default component.exports